(() => {
  const root = document.querySelector('[data-region-redirect]');
  if (!root) return;

  const configEl = root.querySelector('[data-region-redirect-config]');
  const dialog = root.querySelector('[data-region-redirect-dialog]');
  if (!configEl || !dialog) return;

  const decodeHtml = (value) => {
    const el = document.createElement('textarea');
    el.innerHTML = String(value || '');
    return el.value;
  };

  const decodeStrings = (value) => {
    if (typeof value === 'string') return decodeHtml(value);
    if (Array.isArray(value)) return value.map(decodeStrings);
    if (value && typeof value === 'object') {
      return Object.fromEntries(Object.entries(value).map(([key, nested]) => [key, decodeStrings(nested)]));
    }
    return value;
  };

  let config;
  try {
    config = decodeStrings(JSON.parse(decodeHtml(configEl.textContent)));
  } catch (error) {
    console.warn('Region redirect config is invalid:', error);
    return;
  }

  const hostname = window.location.hostname.replace(/^www\./, '');
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1') || window.Shopify?.designMode) {
    return;
  }

  const STORAGE_KEY = 'yarbo:region-redirect-dismissed';

  const getDismissed = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  };

  const dismiss = (country) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ country, at: Date.now() }));
    } catch (e) {
      // Safari private mode
    }
  };

  const countryName = (code) => {
    try {
      return new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }).of(code) || code;
    } catch (e) {
      return code;
    }
  };

  const interpolate = (template, vars) =>
    String(template || '')
      .replaceAll('%%country%%', vars.country)
      .replaceAll('%%store%%', vars.store);

  const resolveTarget = (country) => {
    let domain = config.regionMap?.[country];
    if (!domain && config.euCountries?.includes(country)) {
      domain = config.euDomain;
    }
    return domain ? domain.replace(/^www\./, '') : null;
  };

  const openModal = ({ country, targetDomain }) => {
    const countryLabel = countryName(country);
    const store = config.storeLabels?.[targetDomain] || countryLabel || targetDomain;
    const vars = { country: countryLabel, store };
    const strings = config.strings || {};

    root.querySelector('[data-region-redirect-title]').textContent = interpolate(strings.title, vars);
    root.querySelector('[data-region-redirect-text]').textContent = interpolate(strings.text, vars);
    root.querySelector('[data-region-redirect-stay]').textContent = strings.stay || '';
    root.querySelector('[data-region-redirect-go]').textContent = interpolate(strings.go, vars);

    const targetUrl = window.location.protocol + '//' + targetDomain + window.location.pathname + window.location.search + window.location.hash;

    const stay = () => {
      dismiss(country);
      if (dialog.open) dialog.close();
    };

    dialog.querySelector('[data-region-redirect-stay]').addEventListener('click', stay, { once: true });
    dialog.querySelector('[data-region-redirect-close]').addEventListener('click', stay, { once: true });
    dialog.querySelector('[data-region-redirect-go]').addEventListener(
      'click',
      () => {
        window.location.replace(targetUrl);
      },
      { once: true },
    );
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      stay();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) stay();
    });

    dialog.showModal();
  };

  fetch('https://www.cloudflare.com/cdn-cgi/trace')
    .then((response) => response.text())
    .then((data) => {
      const countryMatch = data.match(/loc=([A-Z]+)/);
      if (!countryMatch) return;

      const country = countryMatch[1];
      const targetDomain = resolveTarget(country);
      if (!targetDomain || hostname === targetDomain) return;

      const dismissed = getDismissed();
      if (dismissed?.country === country) return;

      openModal({ country, targetDomain });
    })
    .catch((error) => {
      console.warn('Region redirect failed:', error);
    });
})();
